<template>
  <v-dialog v-model="dialog" min-width="280" max-width="480">
    <template v-slot:activator="slot_params">
      <slot v-bind="modified_slot(slot_params)"></slot>
    </template>

    <v-form @submit="submit" v-model="valid">
      <v-card>
        <div class="text-right">
          <v-btn rounded color="primary" class="ml-auto" text icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!-- {{ trans('app.cancel') }} -->
        </div>
        <div
          class="font-weight-bold title text-center my-2"
        >{{ trans('app.contact_advertiser_email') }}</div>
        <v-card-text v-if="has_messages" id="conversation" style="height: 180px; overflow-y: auto;">
          <div v-if="conversation.messages">
            <div v-for="(message,i) in conversation.messages">
              <div v-if="message.recipient_uuid == to">
                <v-alert dense text color="secondary">
                  <v-row>
                    <v-col class="py-0">
                      <small>You</small>
                    </v-col>
                    <v-col cols="auto" class="ml-auto py-0">
                      <small>{{ moment(message.created_at) }}</small>
                    </v-col>
                  </v-row>
                  <div>{{ message.message }}</div>
                </v-alert>
              </div>
              <div v-else>
                <v-alert dense text color="primary">
                  <v-row>
                    <v-col class="py-0">
                      <small>{{ username }}</small>
                    </v-col>
                    <v-col cols="auto" class="ml-auto py-0">
                      <small>{{ moment(message.created_at) }}</small>
                    </v-col>
                  </v-row>
                  <div>{{ message.message }}</div>
                </v-alert>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-text class="pt-5 pb-0">
          <v-text-field
            v-show="!has_messages"
            :loading="loading"
            filled
            background-color="#F1F2F6"
            disabled
            :label="trans('message.to_user')"
            readonly
            :value="username"
            :error="hasError('recipient_uuid')"
            :error-messages="getError('recipient_uuid')"
            @input="unsetError('recipient_uuid')"
          ></v-text-field>

          <v-textarea
            v-show="!sent"
            transition="expand-transition"
            filled
            background-color="#F1F2F6"
            required
            name="message"
            v-model="message"
            :rows="3"
            :label="trans('message.message')"
            :placeholder="trans('message.message_placeholder')"
            :rules="message_rules"
            :counter="true"
            :disabled="!authenticated"
            :error="hasError('message')"
            :error-messages="getError('message')"
            @input="unsetError('message')"
          ></v-textarea>

          <v-alert
            :value="sent"
            :dismissible="false"
            type="success"
            class="my-1"
          >{{ trans('message.sent') }}</v-alert>
        </v-card-text>

        <v-card-actions>
          <v-btn
            rounded
            block
            type="submit"
            :loading="sending"
            :disabled="!valid || !authenticated || sent"
            color="primary"
          >{{ trans('message.send') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions, mapGetters } from "vuex";
import EventBus from "../event_bus";

export default {
  props: ["username", "to"],

  data: () => ({
    valid: false,
    message: "",
    dialog: false,
    sent: false
  }),

  computed: {
    ...mapState("auth", {
      authenticated: "authenticated",
      sender_uuid: "user"
    }),
    ...mapState("chat", {
      sending: "instance_saving",
      // sent: 'instance_saved',

      loading: "fetching",
      conversation: "conversation"
    }),
    ...mapGetters({
      getError: "errors/get",
      hasError: "errors/has"
    }),

    message_rules: function() {
      return [
        () => _.size(this.message) <= 500 || "Max 500 characters",
        () => _.size(this.message) >= 10 || "Min 10 characters"
      ];
    },

    modified_slot: function() {
      return slot_params => {
        let default_action = slot_params.on.click;
        let alternate_action = () => EventBus.$emit("requiresAuth", null);
        return {
          ...slot_params,
          on: {
            click: this.authenticated ? default_action : alternate_action
          }
        };
      };
    },

    has_messages: function() {
      return _.size(_.get(this.conversation, "messages", []));
    }
  },

  methods: {
    ...mapActions("chat", {
      send: "store",
      load: "load",
      updateInstance: "updateInstance",
      resetInstance: "resetInstance"
    }),

    ...mapActions("errors", {
      clearErrors: "clear",
      unsetError: "unset"
    }),

    submit: function(e) {
      e.preventDefault();
      let payload = {
        recipient_uuid: this.to,
        message: this.message
      };
      this.updateInstance(payload);
      this.clearErrors();
      this.send();
    },

    resetForm: function() {
      this.resetInstance();
      this.message = "";
      this.dialog = false;
      this.sent = false;
    }
  },

  watch: {
    dialog: function(value) {
      if (value == true) this.load({ recipient_uuid: this.to });
    }
  },

  mounted: function() {
    this.resetInstance();

    // this.load({recipient_uuid: this.to});

    this.$store.subscribe(({ type, payload }, state) => {
      if (type == "chat/handleSent") {
        this.sent = true;
        this.load({ recipient_uuid: this.to });
        setTimeout(() => this.resetForm(), 5000);
      }
      if (type == "chat/handleFailed") {
      }
      if (type == "chat/handleConversationLoaded") {
        this.$nextTick(function() {
          var objDiv = document.getElementById("conversation");
          if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
        });
      }
    });
  }
};
</script>